import { render, staticRenderFns } from "./MacroItem.vue?vue&type=template&id=535f5a93&scoped=true&"
import script from "./MacroItem.vue?vue&type=script&lang=js&"
export * from "./MacroItem.vue?vue&type=script&lang=js&"
import style0 from "./MacroItem.vue?vue&type=style&index=0&id=535f5a93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f5a93",
  null
  
)

export default component.exports